<template>
    <main id="login-wrapper">
        <div id="loginpage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Lupa Akun/Pin atau Buat Pin', url: app_url+'/forgot', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div id="card-login" class="card mb-4">
                            <div class="card-body">
                                <div v-if="showForgot">
                                    <form
                                        method="POST"
                                        @submit.prevent="onSubmit"
                                        @keydown="form.errors.clear($event.target.name)"
                                        enctype="multipart/form-data"
                                    >
                                    <div id="card-register" class="cards">
                                    <div class="card-bodys">
                                        <h3 class="title">Lupa Akun/Pin atau Buat Pin</h3>
                                        <p>Masukkan No. Handphone atau email yang Anda ingat</p>

                                        <div class="form-group row">
                                            <div class="col">
                                                <div class="phonebox">
                                                    <span class="input62">+62</span>
                                                    <input
                                                        type="number"
                                                        pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        class="form-control form-register"
                                                        id="hp"
                                                        aria-describedby="hp"
                                                        placeholder="8XXXXXXXX"
                                                            v-model="form.phone"
                                                    />
                                                </div>
                                                <span v-if="showWarning">Pastikan nomor Handphone yang digunakan sudah benar, jika sudah silahkan klik Selanjutnya</span>
                                                <span
                                                class="help-block"
                                                v-if="form.errors.has('phone')"
                                                v-text="form.errors.get('phone')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <label class="label-form-or">Atau</label>
                                        <div class="form-group row">
                                            <div class="col">
                                                <input
                                                    type="text"
                                                    class="form-control form-register"
                                                    id="email"
                                                    aria-describedby="email"
                                                    placeholder="email@astra-honda.com"
                                                        v-model="form.email"
                                                />
                                                <span
                                                class="help-block"
                                                v-if="form.errors.has('email')"
                                                v-text="form.errors.get('email')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row-button">
                                           <!-- <a :href="app_url+'/register'" class="btn btn-black">Daftar</a> -->
                                            <div v-if="loader" class="loading loading-double"></div>
                                            <button v-else
                                            type="submit"
                                            class="btn btn-red"
                                            >
                                            Next
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    </form>
                                </div>
                                <div v-else>
                                    <div class="message-box" v-if="showMessage">
                                        <div class="message-content">
                                             <div v-html="member.message"></div>
                                            <button class="btn btn-red" @click="showMessage = !showMessage"> Selanjutnya </button>
                                        </div>
                                    </div>
                                    <div class="message-box" v-if="showMessageSuccess">
                                        <div class="message-content">
                                             <div v-html="member.message"></div>
                                             <a :href="nexturl" class="btn btn-red">Selanjutnya</a>
                                        </div>
                                    </div>
                                    <form
                                        method="POST"
                                        @submit.prevent="onSubmitWithOtp"
                                        @keydown="otpForm.errors.clear($event.target.name)"
                                        enctype="multipart/form-data"
                                    >
                                    <div id="card-register" class="cards">
                                    <div class="card-bodys">
                                        <h3 class="title">Verifikasi</h3>
                                        <div class="form-group row">
                                            <div class="col">
                                            <label class="label-form" for="hp">Akun anda</label>
                                             <div class="member-box">
                                                 <strong>{{ member.hcid }}</strong>
                                                 <span>{{ member.email }}</span>
                                                 <span>{{ member.phone }}</span>
                                             </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col">
                                            <label class="label-form" for="hp">Kode OTP</label>
                                            <input
                                                type="number"
                                                pattern="[0-9]*"
                                                inputmode="numeric"
                                                class="form-control form-register"
                                                id="otp"
                                                aria-describedby="otp"
                                                placeholder="Masukkan No OTP"
                                                v-model="otpForm.otp"
                                                v-mask="'######'"
                                            />
                                                <span
                                                class="help-block"
                                                v-if="otpForm.errors.has('otp')"
                                                v-text="otpForm.errors.get('otp')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col">
                                            <label class="label-form" for="pin">Masukkan PIN Baru</label>
                                            <input
                                                type="number"
                                                pattern="[0-9]*"
                                                inputmode="numeric"
                                                class="form-control form-register"
                                                id="pin"
                                                aria-describedby="pin"
                                                placeholder="PIN Harus berupa 6 Angka"
                                                v-model="otpForm.pin"
                                                v-mask="'######'"
                                            />
                                                <span
                                                class="help-block"
                                                v-if="otpForm.errors.has('pin')"
                                                v-text="otpForm.errors.get('pin')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col">
                                            <label class="label-form" for="hp">Konfirmasi Pin</label>
                                            <input
                                                type="number"
                                                pattern="[0-9]*"
                                                inputmode="numeric"
                                                class="form-control form-register"
                                                id="pin_confirmation"
                                                aria-describedby="pin_confirmation"
                                                placeholder="Konfirmasi Pin"
                                                v-model="otpForm.pin_confirmation"
                                                v-mask="'######'"
                                            />
                                                <span
                                                class="help-block"
                                                v-if="otpForm.errors.has('pin_confirmation')"
                                                v-text="otpForm.errors.get('pin_confirmation')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="loader" class="loading loading-double"></div>
                                        <div  v-else class="row-button">
                                            <div class="sendback">
                                                    <button
                                                    type="button"
                                                    class="btn btn-black"
                                                    :disabled="countDown != 0"
                                                    @click="backOTp"
                                                    >
                                                    Kirim Ulang OTP
                                                    </button>
                                                <small v-if="countDown > 0"> Kirim Ulang OTP Dalam {{countDown}} Detik</small>
                                            </div>
                                            <button
                                            type="submit"
                                            class="btn btn-red"
                                            >
                                            Verifikasi
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    </form>
                                </div>
                                <div class="row-forgot">
                                    <p>Belum punya akun ? <a :href="app_url+'/register/independent'">Klik di sini untuk daftar</a><br>
                                      Bila ada kendala untuk Login / Register <a target="_blank" href="https://www.astra-honda.com/helpcenter/topic/community-faq">Hubungi Help Center</a><br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            help_url:null,
            mobile: false,
            countDown:60,
            token:'',
            loader:false,
            showWarning:false,
            showForgot:true,
            showMessage:false,
            showMessageSuccess:false,
            nexturl:'',
            member:{
                hcid:'HC002121',
                phone:'0821021019',
                email:'chit.eureka@gmail.com',
            },
            tokenForm: new Form({
                token:'',
            }),
            otpForm: new Form({
                _token:token,
                phone:'',
                otp:'',
                pin:'',
                pin_confirmation:'',
            }),
            form: new Form({
                _token:token,
                phone:'',
                email:'',
                }),
        };
    },
    watch: {
        form: {
            handler: function(val, oldVal) {
                 this.form.email = val.email.toLowerCase();
            },
            deep: true
        }
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.help_url = help_faq_url;
        this.mobile = isMobile;
        localStorage.setItem('method', 'Login');
    },
    methods: {
        loginPhone(){
            this.showLoginPhone = true;
        },
        onSubmit() {
        this.loader = true;
        this.form.post(api_url+"/member/forgot")
            .then((response) => {
                if(response.status){
                    this.member = response.member;
                    this.otpForm.phone = response.member.otp;
                    this.form._token = token;
                    this.form.phone = response.req_phone;
                    this.form.email = response.req_email;
                    this.showForgot = false;
                    this.showMessage = true;
                    this.countDown = 60;
                    this.countDownTimer();
                }
                this.loader = false;
            })
            .catch((response) => {
                this.loader = false;
                     console.log(response);
            });
        },
        onSubmitWithOtp() {
         this.loader = true;
         this.otpForm.post(api_url+"/member/forgot-otp")
            .then((response) => {
                if (response.status) {
                    this.member = response.member;
                    this.tokenForm.token = response.token;
                    this.getUser();
                }
            })
            .catch((response) => {
                 console.log("ERROR");
            });
        },
        getToken() {
        this.tokenForm.post(api_url+"/auth/social/get-token")
            .then((response) => {
                this.token = response.data.token;

                localStorage.setItem('token',this.token)
            })
            .catch((response) => {
                        console.log(response);
            });
        },
        countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
        backOTp(){
            this.showForgot = true;
            this.showWarning = true;
        },
        getUser() {
                axios.get(api_url+'/member/profile',{
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
                }).then(response => {
                        console.log(response.data.data);
                        if(response.data.success){
                            localStorage.setItem('user',JSON.stringify(response.data.data))
                            this.showMessageSuccess = true;
                            this.nexturl = this.app_url + '/hcid';
                        }
                    }).catch(error => {
                        console.log(error);
                    });
        },
    },
};
</script>

<style scoped lang="scss">
#loginpage{
    background: #000000;
    #card-login{
        background: #FFFFFF;
        border-radius: 10px;
        // font-family: Inter;
    }
    .title{
        color: #000000;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
    }
    .btn{
        width:100%;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        padding-left: 0;
        text-align: left;
    }
    #btn-login-google{
        background: #4081EC;
        color: #FFFFFF;
        border-radius: 5px;
    }
    #btn-login-handphone{
        background: #E61B33;
        border-radius: 5px;
        color: #FFFFFF;
    }
    .login-handphone{
        span{
            line-height: 30px;
            font-size: 16px;
            color:#E61B33;
            display: block;
        }
    }
    #btn-login-facebook{
        background: #3B5998;
        border-radius: 5px;
        color: #FFFFFF;
    }
    #btn-login-twitter{
        background: #1DA1F2;
        border-radius: 5px;
        color: #FFFFFF;
    }
    #daftar-link{
        color: #727272;
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
    }
    .btn:hover{
        background-color: #333 !important;
        color:#fff;
    }
    .img-button{
        /* max-width: 20px; */
        background: #FFFFFF;
        border-radius: 5px;
    }
    #icon-section{
        position: absolute;
        left: 19px;
        bottom:4px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
    .text-btn{
        margin-left: 45px;
    }
    .row-button{
        display: flex;
        .btn{
            font-weight: bold;
            font-size: 16px;
            padding: 0;
            height: 38px;
            max-width: 115px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
                color:#fff;
            }
        }
        .btn-red{
            margin-left: auto;
        }
        .info-text{
            margin-right: 10px;
        }
        .sendback{
            margin-right: auto;
            .btn{
                min-width: 160px;
            }
        }
    }
    .row-forgot{
        padding:30px 0 0 0;
        p{
            color:#000;
        }
        a{
            font-weight: bold;
        }
    }
    .card-body{
        position: relative;
        color:#333;
    }
    .message-box{
        position: absolute;
        background: #fff;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        .message-content{
            max-width: 80%;
            margin:auto;
            .btn{
                text-align: center;
            }
        }
    }
    .member-box{
        padding: 15px;
        background: #f2f2f2;
        border-radius: 10px;
        strong,span{
            color:#000;
            display: block;
        }
    }
    p{
        color:#000;
    }
    h3{
        font-weight:bold;
        font-size: 18px;
        color:#000;
    }
}
</style>
